import { render, staticRenderFns } from "./ModalRole.vue?vue&type=template&id=5049287c&scoped=true"
import script from "./ModalRole.vue?vue&type=script&lang=js"
export * from "./ModalRole.vue?vue&type=script&lang=js"
import style0 from "./ModalRole.vue?vue&type=style&index=0&id=5049287c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5049287c",
  null
  
)

export default component.exports